import { useParams } from 'js/lib/useRouter';

import { useProgramBySlug } from 'bundles/enterprise-admin-hooks/enterprise-admin-hooks-index';

export const useProgram = () => {
  const { programDraftSlug } = useParams();
  const program = useProgramBySlug(programDraftSlug);
  return program;
};
